import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, ViewChild, WritableSignal, computed, signal } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DialogService } from 'src/app/core/services/dialog.service';
import { PageComponent } from 'src/app/layout/pages/page/page.component';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { FilesizePipe } from 'src/app/core/pipes/filesize.pipe';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { GoogleMap, GoogleMapsModule, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { PuntiCampionamentoService } from '../../punti-campionamento/punti-campionamento.service';
import { WaterSupplyZoneService } from '../water-supply-zone.service';
import { CardComponent } from "../../../shared/components/cards/card/card.component";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { InputTextComponent } from "../../../shared/components/inputs/input-text/input-text.component";
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { InputSelectStringComponent } from "../components/input-select-string/input-select-string.component";
import { LayerGeografici } from '../models/layer-geografici';
import { AuthService } from 'src/app/core/services/auth.service';
import { Ability } from '@casl/ability';
@Component({
  selector: 'app-layer-geo-water-supply-zone',
  standalone: true,
  imports: [
    CommonModule,
    MatDividerModule,
    MatProgressBarModule,
    PageComponent,
    GoogleMapsModule,
    MyButtonComponent,
    FilesizePipe,
    MatProgressSpinnerModule,
    CardComponent,
    InputTextComponent,
    InputSelectStringComponent
],
  templateUrl: './layer-geo-water-supply-zone.component.html',
  styleUrl: './layer-geo-water-supply-zone.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayerGeoWaterSupplyZoneComponent {
  isLoading = signal(false);
  canSendGeoTextArea = computed(() => this.geoJsonTextArea() !== undefined);
  geoJsonTextArea: WritableSignal<any> = signal(undefined);
  comuni:LayerGeografici[]=[{id:0, nome:'', istatRegione:'', sez21Id:'', denAsc1:''}]
  zonaCensuaria:LayerGeografici[]=[{id:0, nome:'', istatRegione:'', sez21Id:'', denAsc1:''}]
  areaSubComunale:LayerGeografici[]=[{id:0, nome:'', istatRegione:'', sez21Id:'', denAsc1:''}]
  localita:LayerGeografici[]=[{id:0, nome:'', istatRegione:'', sez21Id:'', denAsc1:''}]
  isDisabledAllInput=true
  canSend = computed(() => this.selectedFile() !== undefined);
  selectedFile: WritableSignal<any> = signal(undefined);
  isCheckingElaborazione = signal(false);
  dragging = signal(false);
  showData = false
  comuneGeoJsonEvento:any
  isDisableMostraMappa= false
  insertForm: FormGroup;
  createPermission: boolean = false;
  abilityDefined: boolean = false;
  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  center: google.maps.LatLngLiteral = { lat: 41.8992, lng: 12.5450 };
  zoom = 5.3;
  istatComune=''
  isEmpty: boolean = true;
  options: google.maps.MapOptions = {
    mapTypeId: 'roadmap',
/*     tilt: 0,
    clickableIcons: false,
    disableDefaultUI: true,
    disableDoubleClickZoom: true,
    zoomControl: true,
    scrollwheel: false,
    gestureHandling: 'auto',
    keyboardShortcuts: false,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,  */
  };

  constructor(
    private router:Router,
    private dialogService: DialogService,
    private readonly service: WaterSupplyZoneService,
    private ref:ChangeDetectorRef,
    private readonly fb: FormBuilder,
    private ability: Ability,
    private authService: AuthService,
    @Inject(SnackbarService) protected  readonly snackbar: SnackbarService,
  ) {
      this.insertForm = this.fb.group({
        comune: new FormControl(new Array(), ),
        zonaCensuaria: new FormControl(new Array(), ),
        areaSubComunale: new FormControl(new Array(), ),
        localita: new FormControl(new Array(),),
        nome: new FormControl('', [Validators.required]),
        myGeoJson: new FormControl('', ),
      });
   }


    ngOnInit(): void {
      this.authService.abilityDefined$.subscribe((abilityDefined) => {
        this.abilityDefined = abilityDefined;
        this.createPermission = this.ability.can('create', 'water-supply-zone');
        // Ora puoi fare altro dopo che l'abilità è stata definita
      });
    }
   

   loadGeoJson(data: any, id : any) {

    this.waitForMapInit().then(() => {
      console.log('Mappa pronta');

      if(this.isValidJSON(data)){
        data=JSON.parse(data)
      }

      
      if (!this.map?.googleMap) return;
  
      const mapInstance = this.map.googleMap;

      const newFeatures =  mapInstance.data.addGeoJson(data);
 
      mapInstance.data.setStyle((feature:any) =>{
          var color = feature.getProperty('fillColor');
          return {
              fillColor: color,
              strokeWeight: 1
          };
      });
      const bounds = new google.maps.LatLngBounds();

      newFeatures.forEach((feature: any) => {
        feature.setProperty('customFeatureId',id);
        const geometry = feature.getGeometry();
   
        geometry.forEachLatLng((latLng: google.maps.LatLng) => {
          bounds.extend(latLng);
        });
      });
   
   
      const center = bounds.getCenter();
      this.center = {
        lat: center.lat(),
        lng: center.lng(),
      };
   
      this.zoom = 10;
      this.ref.detectChanges()
      this.showData=true
       // this.insertForm.get("myGeoJson")?.setValue(data)
      
    });
  }
  isValidJSON(str:any){
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

   waitForMapInit(){
    return new Promise((resolve) => {
      const checkMap = setInterval(() => {
        if (this.map && this.map.googleMap) {
          clearInterval(checkMap);
          resolve(null);
        }
      }, 100); 
    });
  };

  deleteFeature( datoFeature:any) {
    console.log(datoFeature)
    this.waitForMapInit().then(() => {
      
      if (!this.map?.googleMap) return;
  
      const mapInstance = this.map.googleMap;
  
      mapInstance.data.forEach((feature: google.maps.Data.Feature) => {
     
        const fid = feature.getProperty('customFeatureId');

        if (fid == datoFeature[0].id) {
          if (!this.map?.googleMap) return;
          this.map.googleMap.data.remove(feature);
          this.ref.detectChanges()
        }
      });

    });
  }

 mostraComuneMappa(){

      this.loadGeoJson(this.comuneGeoJsonEvento.geoJson, this.comuneGeoJsonEvento.id);
      
      let elementAppoggio: any[] = [];

      const currentValue = this.insertForm.get(this.comuneGeoJsonEvento.nomeCampo)?.value;
      if (Array.isArray(currentValue)) {
        elementAppoggio = currentValue;
      }
  
      elementAppoggio.push({ id: this.comuneGeoJsonEvento.id, nome: this.comuneGeoJsonEvento.nome });
      this.insertForm.get(this.comuneGeoJsonEvento.nomeCampo)?.setValue(elementAppoggio);
 }

  checkContentComune(event: any){
        console.log("event", event);
    if (event) {
      this.isDisableMostraMappa=true
      this.istatComune=event.proCom
      this.comuneGeoJsonEvento = event

    }

    this.isDisabledAllInput=false
  }

  checkContent(event: any) {
    console.log("event", event);
    if (event) {
      this.istatComune=event.proCom

      this.loadGeoJson(event.geoJson, event.id);
      
      let elementAppoggio: any[] = [];

      const currentValue = this.insertForm.get(event.nomeCampo)?.value;
      if (Array.isArray(currentValue)) {
        elementAppoggio = currentValue;
      }
  
      elementAppoggio.push({ id: event.id, nome: event.nome });
      this.insertForm.get(event.nomeCampo)?.setValue(elementAppoggio);

    }

    this.isDisabledAllInput=false

  }

  onSendWszGeojsonClick(){
    const mapInstance = this.map.googleMap;
    if(mapInstance){
      mapInstance.data.toGeoJson((el:any)=>{
        if(Array.isArray(el.features)){
          if(el.features.length>0){
            this.insertForm.get("myGeoJson")?.setValue(el)
            const datiInvio = {
              relazione: {
                ...(this.insertForm.get("comune")?.value && { comune: this.insertForm.get("comune")?.value }),
                ...(this.insertForm.get("zonaCensuaria")?.value && { zonaCensuaria: this.insertForm.get("zonaCensuaria")?.value }),
                ...(this.insertForm.get("areaSubComunale")?.value && { areaSubComunale: this.insertForm.get("areaSubComunale")?.value }),
                ...(this.insertForm.get("localita")?.value && { localita: this.insertForm.get("localita")?.value }),          
              },
              nome:this.insertForm.get("nome")?.value,
              myGeoJson: this.insertForm.get("myGeoJson")?.value
            }
            
            this.service.invioJsonWsz(datiInvio).subscribe((ell:any)=>{
              this.snackbar.success("Dati salvati con successo")
              this.resetForm()
              this.insertForm.reset()
              console.log(ell)
              this.router.navigate(['water-supply-zone/'+ell.id])
            })
          }
        }
      })
    }


  }

  resetForm() {
    this.selectedFile.set(undefined);
  }

}
